import config from "@config";

interface Features {
  webSearchEnabled: boolean;
  isDemoMode: boolean;
  whatsapp: boolean;
  sharePoint: boolean;
  analyticsDashboard: boolean;
}

export interface AppConfig {
  name: string;
  themeColor: string;
  assistantName: string;
  logo: string;
  welcomeMessage: string;
  features: Features;
}

export const appConfig: AppConfig = {
  name: config.name,
  themeColor: config.themeColor,
  assistantName: config.assistantName,
  logo: config.logo,
  welcomeMessage: config.welcomeMessage.replace(
    "{ASSISTANT_NAME}",
    config.assistantName,
  ),
  features: {
    webSearchEnabled: config.features.webSearch,
    isDemoMode: config.features.isDemoMode,
    whatsapp: config.features.whatsapp,
    sharePoint: config.features.sharePoint,
    analyticsDashboard: config.features.analyticsDashboard ?? false,
  },
};

// Template for dynamic welcome message (with placeholder)
export const welcomeMessageTemplate: string = config.welcomeMessage;

export const APP_NAME = appConfig.name;
